import React, { FC, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Box, Spinner } from '@chakra-ui/react';

import { useHeader } from '@app/components/common/navigation/hooks/header-service';
import { useAlert, useApi } from '@app/hooks';

import { AgreementFormInstance } from './types';
import AgreementForm from './form';
import { Paper } from '../common/paper';

type EquipmentsCreateProps = {};

const AgreementEdit: FC<EquipmentsCreateProps> = () => {
  useHeader('Изменить соглашение', []);
  const params = useParams<{ id: string }>();
  const api = useApi();
  const { error, success } = useAlert();
  const history = useHistory();


  const [instance, setInstance] = useState<AgreementFormInstance | undefined>(
    undefined
  );
  const [loading, setLoading] = useState<boolean>(true);

  // const loading = useSelector<RootState, boolean>(state => state.agreements.loading)

  useEffect(() => {
    if (params.id) {
      setLoading(true);
      api.agreements.getAgreements({
        filter: { id: params.id },
        sort: '+id',
        limit: 1,
        offset: 0,
      }).then(({ code, data }) => {
        if (code !== 200) {
          error('Ошибка получения соглашения');
          return;
        }
        setLoading(false);
        setInstance({
          ...data.data[0],
          files: [],
        });
      });
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  const onFormSubmit = async (instance: Partial<AgreementFormInstance>) => {
    setLoading(true);
    const { data: response } = await api.agreements.updateAgreement({
      id: params.id,
      type_id: instance.type?.id || null,
      outlet_id: instance.outlet?.id || null,
      distributor_id: instance.distributor?.id || null,
      number: instance.number || null,
      name: instance.name,
      date_open: instance.date_open || null,
      date_close: instance.date_close || null,
      comment: instance.comment || null,
      ...(instance.files?.[0]
        ? {
            filename: instance.files?.[0]?.file.name || '',
            content: instance.files?.[0]?.data || '',
          }
        : {}),
    });

    const { code, message, data } = response;

    if (code !== 200) {
      error(message);
      setLoading(false);
      return;
    }

    await api.agreements.updateAgreementEquips({
      agreement_id: data.id,
      equips:
        instance.equips
          ?.filter((item) => item.id)
          .map((item) => item.id?.toString() || '') || [],
    });

    setLoading(false);
    success('Соглашение изменено');
    history.push('/agreements/');
  };

  const onFormCancel = () => {
    history.push('/agreements/');
  };

  return (
    <Box paddingX={{ xs: 0, sm: 2, md: 10, lg: 14, xl: 20 }}>
      <Paper>
        <Box paddingX={4} paddingY={6}>
          {!instance ? (
            <Box
              width="100%"
              height="300px"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Spinner />
            </Box>
          ) : (
            <AgreementForm
              loading={loading}
              instance={instance}
              onSubmit={onFormSubmit}
              onCancel={onFormCancel}
              submitText="Изменить"
            />
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default AgreementEdit;
